import { useState } from 'react'

import FollowUpBubble from './FollowUpBubble'

import { useChatContext } from '../../ChatProvider'
import { useMessageContext } from '../../modules/Message'

export default function SuggestedPrompts() {
	const options = useChatContext()
	const { message, isLastMessage, onFollowUp, isReasoning } = useMessageContext()
	const [currentPromptIndex, setCurrentPromptIndex] = useState(0)

	return (
		<div>{
			options.displaySuggestedPrompts && message.suggestedPrompts && message.suggestedPrompts.length > 0 && isLastMessage ? <div className='suggestedprompts lg:mx-auto md:mx-4 mx-2 lg:max-w-2xl xl:max-w-3xl items-center flex relative h-[60px] overflow-x-clip w-full z-0' style={ { display: 'flex' } }>
				<button
					className='absolute left-0 z-10 bg-white text-black h-full'
					onClick={ () => {
						setCurrentPromptIndex(prevIndex => prevIndex === 0 ? 2 : prevIndex - 1)
					} }
				>
					{ /* &#10094; = left arrow */ }
						&#10094;
				</button>
				<div
					className='flex transition-transform duration-300 w-full h-full'
					style={ { transform: `translateX(-${currentPromptIndex * 100}%)` } }
				>
					{ message.suggestedPrompts.map((prompt, index) => (
						<div
							key={ index }
							className='flex w-full px-2 pr-4 flex-shrink-0 h-full'
						>
							<div className='w-full p-1 content-center'>
								<FollowUpBubble
									text={ prompt }
									onClick={ () => {
										if (onFollowUp) {
											onFollowUp(prompt, isReasoning ?? false)
										}
									} }
								/>
							</div>
						</div>
					)) }
				</div>
				<button
					className='absolute right-0 z-10 bg-white text-black h-full'
					onClick={ () => {
						setCurrentPromptIndex(prevIndex => prevIndex === 2 ? 0 : prevIndex + 1)
					} }
				>
					{ /* &#10095; = right arrow */ }
						&#10095;
				</button>
			</div> : null
		}
		</div>
	)
}
